import styled, { css } from 'styled-components/macro';

import { Flex } from 'components/styled/Flex';

export const Container = styled.div<{
  type?: string;
  disabled?: boolean;
  backgroundColor?: string;
}>`
  position: relative;
  margin-bottom: ${({ theme, type }) => type === 'primary' && theme.spacing.one};
  border: 1px solid ${({ theme }) => theme.colors.black_20};
  border-radius: 8px;

  background-color: ${({ theme, backgroundColor, type }) =>
    backgroundColor ? backgroundColor : type === 'secondary' && theme.colors.black_5};

  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: ${({ theme, type }) => type === 'primary' && theme.spacing.zero_3};
  }
  :after {
  }
  ${({ disabled }) =>
    disabled &&
    css`
      :after {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.08);

        content: '';
      }
    `}
`;

export const AccordionHeader = styled.div<{
  type?: string;
  expanded?: boolean;
  disableBorderBottom?: boolean;
  padding?: string;
  backgroundColorHeader?: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme, backgroundColorHeader }) =>
    backgroundColorHeader ? backgroundColorHeader : theme.colors.white};
  padding: ${({ padding, theme, type }) =>
    type === 'secondary'
      ? theme.spacing.one
      : padding
      ? padding
      : `${theme.spacing.one_2} ${theme.spacing.two}`};

  border-bottom: ${({ theme, type, expanded, disableBorderBottom }) =>
    type === 'primary' && !disableBorderBottom
      ? expanded && `1px solid ${theme.colors.black_20}`
      : 'none'};

  cursor: pointer;

  z-index: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme, type }) =>
      type === 'primary' ? `${theme.spacing.one}` : `${theme.spacing.one_2} ${theme.spacing.two}`};
    align-items: self-start;
  }
`;

const PrimaryAccordionTitle = css`
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
`;

const SecondaryAccordionTitle = css`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
`;

export const AccordionTitleWrapper = styled(Flex)`
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-flow: column;
  }
`;

export const AccordionTitle = styled.h2<{
  type?: string;
  width?: string;
  titleBorder?: boolean;
  titleBadgeReverseChipMobile?: boolean;
}>`
  display: flex;
  align-items: center;

  ${({ titleBorder, theme }) =>
    titleBorder && `border-left: 1px solid ${theme.colors.black_20}; padding: 0 0 0 1.5rem;`}

  color: ${({ theme }) => theme.colors.black_100};

  width: ${({ width }) => width && width};

  ${({ type }) => (type === 'primary' ? PrimaryAccordionTitle : SecondaryAccordionTitle)}

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    padding-left: 0;
    :not(:last-child) {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
      width: 100%;
      padding: 0 0 0.75rem 0;
    }

    > button {
      margin: 0 0 0.75rem 0;
    }

    border-left: none;

    ${({ titleBadgeReverseChipMobile }) =>
      titleBadgeReverseChipMobile &&
      ` :first-child {
        flex-flow: column-reverse;
    }`};

   
`;

//collapsed accordion styles (form styles)
export const FormTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.one} ${({ theme }) => theme.spacing.two};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme }) => theme.spacing.one} ${({ theme }) => theme.spacing.zero_3};
  }
`;

export const FormTitle = styled.h3<{ disabled?: boolean; asterisk?: boolean }>`
  position: relative;

  color: ${({ theme }) => theme.colors.black_80};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.colors.black_40};
    `}

  ${({ asterisk }) =>
    asterisk &&
    css`
      :after {
        position: absolute;
        top: 0;
        right: -${({ theme }) => theme.spacing.zero_2};

        color: ${({ theme }) => theme.colors.negative_default};
        font-size: ${({ theme }) => theme.fontSize.md};
        font-family: ${({ theme }) => theme.fontFamily.semiBold};

        content: '*';
      }
    `}
`;

export const IconWrapper = styled.div`
  cursor: pointer;

  :hover {
    svg path {
      stroke: ${({ theme }) => theme.colors.black_100};
    }
  }
`;

export const FormSection = styled.div<{ padding?: string; mobileMb: string }>`
  padding: ${({ theme, padding }) => (padding ? padding : `0 ${theme.spacing.two}`)};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: ${({ mobileMb }) => mobileMb};
    padding: ${({ theme }) => `0 ${theme.spacing.zero_3}`};
  }
`;

export const AccordionColumnsContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.white};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-flow: column;
    div {
      width: 100%;
    }

    > div {
      border-top: 1px solid ${({ theme }) => theme.colors.black_10};

      border-left: none;
      padding: 0 0 1rem 0;
      h3 {
        margin-top: 1rem;
      }
    }

    > div:last-child {
      padding-top: 1rem;
      border-bottom: 1px solid ${({ theme }) => theme.colors.black_10};
    }
  }
`;
